export default __webpack_public_path__ + "static/media/des-5.5798fc4e.jpg";